export const SET_USER_STATE = 'SET_USER_STATE';
export const DROP_USER_STATE = 'DROP_USER_STATE';

export const TOGGLE_CREATE_CAMPAIGN_MODAL = 'TOGGLE_CREATE_CAMPAIGN_MODAL';
export const CAMPAIGN_SAVED = 'CAMPAIGN_SAVED';

export const PROMOTION_SAVED = 'PROMOTION_SAVED';
export const PROMOTION_UPDATE_TEXTFIELD_VALUE = 'PROMOTION_UPDATE_TEXTFIELD_VALUE';
export const PROMOTION_UPDATE_POSITION_VALUE = 'PROMOTION_UPDATE_POSITION_VALUE';
export const PROMOTION_ADD_PERIOD = 'PROMOTION_ADD_PERIOD';
export const PROMOTION_ADD_PERIOD_VARIANT = 'PROMOTION_ADD_PERIOD_VARIANT';
export const PROMOTION_UPDATE_POSITION_FIELD_VALUE = 'PROMOTION_UPDATE_POSITION_FIELD_VALUE';
export const PROMOTION_SET = 'PROMOTION_SET';
export const PROMOTION_RESET = 'PROMOTION_RESET';
export const PROMOTION_REMOVE_VARIATION = 'PROMOTION_REMOVE_VARIATION';
export const PROMOTION_REMOVE_PERIOD = 'PROMOTION_REMOVE_PERIOD';

export const CAMPAIGNS_SETTINGS_UPDATE_FIELD_VALUE = 'CAMPAIGNS_SETTINGS_UPDATE_FIELD_VALUE';
export const CAMPAIGNS_SETTINGS_ADD_FIELD = 'CAMPAIGNS_SETTINGS_ADD_FIELD';
export const CAMPAIGNS_SETTINGS_REMOVE_FIELD = 'CAMPAIGNS_SETTINGS_REMOVE_FIELD';
export const CAMPAIGNS_SETTINGS_UPDATE_FIELD = 'CAMPAIGNS_SETTINGS_UPDATE_FIELD';
export const CAMPAIGNS_SETTINGS_RESET = 'CAMPAIGNS_SETTINGS_RESET';

export const ADD_CAMPAIGN = 'ADD_CAMPAIGN';
export const ADD_CAMPAIGNS = 'ADD_CAMPAIGNS';
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const REMOVE_CAMPAIGN = 'REMOVE_CAMPAIGN';


export const SETTINGS_SAVED = 'SETTINGS_SAVED';

export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const OPEN_SNACKBAR = 'OPEN_SNACKBAR';

export const CLOSE_DIALOG = 'CLOSE_DIALOG';

export const ADD_COMPANIES = 'ADD_COMPANIES';
export const PROMOTION_UPDATE_PERIOD_FIELD_VALUE = 'PROMOTION_UPDATE_PERIOD_FIELD_VALUE';
export const ADD_USERS = 'ADD_USERS';

export const ADD_IMAGES = 'ADD_IMAGES';
export const ADD_TEMP_IMAGES = 'ADD_TEMP_IMAGES';
export const REMOVE_TEMP_IMAGES = 'REMOVE_TEMP_IMAGES';
export const UPDATE_TEMP_IMAGE = 'UPDATE_TEMP_IMAGE';
export const UPDATE_IMAGE = 'UPDATE_IMAGE';
export const RESET_IMAGES = 'RESET_IMAGES';

export const TOPIC_SETTINGS_ADD_TOPICS = 'TOPIC_SETTINGS_ADD_TOPICS';
export const TOPIC_SETTINGS_RESET_TOPICS = 'TOPIC_SETTINGS_RESET_TOPICS';

export const ADD_DELETED_VARIANT = 'ADD_DELETED_VARIANT';
export const SHOW_OVERLAY = 'SHOW_OVERLAY';
export const HIDE_OVERLAY = 'HIDE_OVERLAY';

export const CATEGORIES_SETTINGS_ADD_CATEGORIES = 'CATEGORIES_SETTINGS_ADD_CATEGORIES';


// WEBPACK FOOTER //
// ./src/constants.js